import { createApp } from 'vue'
import { createPinia } from 'pinia'
import 'dayjs/locale/zh-cn'
import 'normalize.css'

import App from './app.vue'
import { i18n, registerHttpLangSync } from '@/i18n'
import { IS_JP_ONLY_BUILD } from '@/common/const/build-locale'
import './assets/scss/base.scss'
import './assets/scss/icon.scss'
import './assets/scss/gap.scss'
import './assets/scss/element.scss'
import './assets/scss/common.scss'
import './assets/scss/scroll.scss'
import './assets/theme/index.css'
import './assets/theme/dashboard-nav-deep.css'
import './assets/theme/dashboard-nav-sky.css'
import './assets/scss/element-sky-theme.scss'
import { initDashboardNavTheme } from '@/utils/dashboard-nav-theme'

initDashboardNavTheme()
import './assets/theme/cm-tokens.css'
import './assets/dark-mode.css'
import './assets/scss/table-drag-sort.scss'
import './assets/scss/cmtable-selection-tip-bar.scss'
import { initAppTheme } from '@/utils/app-theme'

initAppTheme()
import ElementPlus from 'element-plus'
import '@/router/before-resolve'

import { reflectiveInjectorPlugin } from '@tanbo/vue-di-plugin'

import { DateFormatDirective } from '@/directives/date-format.directive'
import { SpeedFormatDirective } from '@/directives/speed-format.directive'
import { DisabledDirective } from '@/directives/disabled-directive'
import { intelLink } from '@/directives/intel-link.directive'
import { loadMore } from '@/directives/load-more.directive'
import '@/assets/global.css'
import { router } from '@/router'
import { BlueTipsIcon, CmSvgIcon } from '@/components/cm-svg-icon'
import { getSvgIconDataUrl } from '@/utils/svg-icon-data-url'

if (IS_JP_ONLY_BUILD) {
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  require('./assets/scss/jp-only-font.scss')
  document.documentElement.classList.add('jp-only-build')
}
import '@/common/basis/sentry'
import { getBaseUrl } from '@/common/const/api-base-url'
import { rootInjector, http } from '@/common/basis/root-injector'
import { rolePermDirective } from '@/directives/role-perm.directive'

registerHttpLangSync((locale) => {
  http.addCommonRequestFields({ lang: locale })
  http.setBaseUrl(getBaseUrl())
})

const pinia = createPinia()
const app = createApp(App)
app.config.globalProperties.getSvgIconDataUrl = getSvgIconDataUrl
app.component('CmSvgIcon', CmSvgIcon)
app.component('BlueTipsIcon', BlueTipsIcon)
app.use(i18n)
  .use(reflectiveInjectorPlugin, rootInjector)
  .use(ElementPlus)
  .directive('date-format', DateFormatDirective)
  .directive('speed-format', SpeedFormatDirective)
  .directive('disabled', DisabledDirective)
  .directive('intel-link', intelLink)
  .directive('role-perm', rolePermDirective)
  .directive('load-more', loadMore)
  .use(router)
  .use(pinia)
  .mount('#app')

app.config.warnHandler = function (msg, vm, trace) {
  console.warn(msg)
}
